import React from 'react'
import classes from './error.module.scss'

const ErrorPage = () => {
    return (
        <div className={classes.container}>
            <h1 className={classes.container__title}>Ooops.....</h1>
            <p className={classes.container__text}>Something is going wrong,please try again later</p>
        </div>
    )
}

export default ErrorPage